module.exports = __webpack_public_path__ + "img/vip_dialog_table_header_bg.81b1d3f3.png";